const userImage = require('../../../../asset/image/user.png');
const locale = require('../../../core.i18n.json');

/*@ngInject*/
const UserProfileModalController = function ($rootScope, $scope, $uibModalInstance, $timeout, coreConstant, coreMediator, loadingBarHandler, currentUserModel, preferenceModel, dataSetUtil, appTypeConfigurationModel, attachmentUtil) {

    function init() {
        $scope.i18n = locale;
        $scope.viewModel = {
            addressLine1: '',
            addressLine2: '',
            cellPhoneNumber: '',
            city: '',
            country: '',
            emailAddress: '',
            faxNumber: '',
            firstName: '',
            lastName: '',
            middleName: '',
            name: '',
            organizationId: '',
            phoneNumber: '',
            phoneNumberExtension: '',
            principalId: '',
            postalCode: '',
            state: '',
            title: '',
            faxNumberError: '',
            phoneNumberError: '',
            cellPhoneNumberError: '',
            zipCode: '',
            userImage: null,
            uploadedFile: null,
            isValidFileSelected: false,
            isProfileManagementEnabled: false,
            chooseFileString: ''
        };

        $scope.viewModel.chooseFileString = _.get($scope.i18n, 'userProfile.userImage.chooseFile');
        $scope.viewModel.faxNumberError = _.get($scope.i18n, 'userProfile.error.faxNumber');
        $scope.viewModel.phoneNumberError = _.get($scope.i18n, 'userProfile.error.phoneNumber');
        $scope.viewModel.cellPhoneNumberError = _.get($scope.i18n, 'userProfile.error.cellPhoneNumberError');
        $scope.viewModel.zipCodeError = _.get($scope.i18n, 'userProfile.error.zipCode');
        $scope.enableActionButton = true;
        $scope.displayProfileForm = true;

        $scope.countryList = [
            {name: 'USA', value: 'USA'},
            {name: 'Canada', value: 'Canada'}
        ];
    }

    $scope.update = function () {
        loadingBarHandler.showLoadingBar('userProfile.updateUserProfileLoadingBar');
        coreMediator.updateUser($scope.viewModel).then(function () {
            loadingBarHandler.hideLoadingBar();
            $uibModalInstance.close();
        });
    };

    $scope.changePhoto = function () {
        if ($scope.viewModel.isProfileManagementEnabled) {
            $scope.displayProfileForm = false;
            $scope.viewModel.chooseFileString = _.get($scope.i18n, 'userProfile.userImage.chooseFile');
        }
    };

    $scope.deleteUserPhoto = function () {
        coreMediator.deleteUserImage().then(function () {
            $scope.displayProfileForm = false;
            setSilhouetteImage();
            $scope.viewModel.isValidFileSelected = false;
            $scope.viewModel.userImage = null;
            $rootScope.$broadcast(coreConstant.event.USER_AVATAR_RELOAD, currentUserModel.getCurrentUser().userId);
        });
    };

    $scope.$on(coreConstant.event.FILE_DROPPED, function (event, file) {
        if (file) {
            $scope.file = file;
            storeUploadedFile(file);
        }
    });

    $scope.fileSelected = function (file) {
        if (file) {
            $scope.file = file;
            storeUploadedFile(file);
        }
    };

    $scope.isDeletePhotoButtonEnabled = function () {
        return $scope.underwriterImage ? true : false;
    };

    $scope.cancelPhotoUpload = function () {
        $scope.displayProfileForm = true;
        $scope.userImage = $scope.underwriterImage;
        if($scope.viewModel.isValidFileSelected) {
            $scope.viewModel.userImage.name = null;
            $scope.viewModel.isValidFileSelected = false;
        }
    };

    $scope.uploadProfilePhoto = function () {

        let onSuccess = function () {
            loadingBarHandler.hideLoadingBar();
            $scope.displayProfileForm = true;
            $scope.underwriterImage = $scope.userImage;
            $scope.doesUserHasStoredImage = true;
            $rootScope.$broadcast(coreConstant.event.USER_AVATAR_RELOAD, currentUserModel.getCurrentUser().userId);
        };

        let onError = function () {
            loadingBarHandler.hideLoadingBar();
        };
        loadingBarHandler.showLoadingBar('userProfile.userImage.imageUploadingLoadingBar');
        coreMediator.updateUserImage($scope.file, $scope.imageWidth, $scope.imageHeight).then(onSuccess, onError);
    };

    function storeUploadedFile(uploadedFile) {
        let allowFile = true,
            allowedUserImageFileTypes = preferenceModel.get('system.allowedUserImageFileTypes'),
            acceptedTypes = _.split(allowedUserImageFileTypes, ';'),
            allowFileType = attachmentUtil.validateAttachmentType(uploadedFile, _.get($scope.i18n, 'userProfile.userImage.unacceptableType'), acceptedTypes),
            maxUploadFileSize = preferenceModel.get('system.maxUserImageUploadSizeInKilobytes'),
            img = new Image();

        if (allowFileType) {
            if (uploadedFile.size / 1024 >= maxUploadFileSize) {
                let notificationMessage = _.get($scope.i18n, 'userProfile.userImage.maxFileSizeMessage');
                notificationMessage = _.replace(notificationMessage, '{maxSize}', maxUploadFileSize);
                $rootScope.$broadcast(coreConstant.event.SHOW_MODAL_NOTIFICATION, {
                    title: _.get($scope.i18n, 'userProfile.userImage.maxFileSizeTitle'),
                    summary: notificationMessage
                });
                allowFile = false;
            }

            if (allowFile) {
                let imageReader = new FileReader();
                imageReader.onload = function (event) {
                    img.src = event.target.result;
                };
                imageReader.readAsDataURL(uploadedFile);
                img.onload = function () {
                    if (this.width !== this.height) {
                        // if image is not square
                        let notificationMessage = _.get($scope.i18n, 'userProfile.userImage.imageSizeMessage');
                        $rootScope.$broadcast(coreConstant.event.SHOW_MODAL_NOTIFICATION, {
                            title: _.get($scope.i18n, 'userProfile.userImage.imageSizeTitle'),
                            summary: notificationMessage
                        });
                    } else {
                        $scope.imageWidth = this.width;
                        $scope.imageHeight = this.height;
                        $timeout(function () {
                            $scope.viewModel.uploadedFile = uploadedFile;
                            if (!$scope.viewModel.userImage) {
                                $scope.viewModel.userImage = {};
                            }
                            $scope.viewModel.userImage.name = uploadedFile.name;
                            $scope.viewModel.userImage.size = uploadedFile.size;
                        }, 0);

                        $scope.viewModel.isValidFileSelected = true;
                        let reader = new FileReader();

                        reader.onload = function (event) {
                            $scope.isSilhouetteImage = false;
                            $scope.userImage = event.target.result;
                            $scope.$apply();
                        };
                        reader.readAsDataURL(uploadedFile);
                    }
                };
            }
        }
    }

    function loadDataSets() {
        dataSetUtil.getDataItems({name: 'States'}).then(function (result) {
            $scope.stateDataProvider = result;
        });
    }

    function showUserProfileImage() {
        coreMediator.loadProfileImage(currentUserModel.getCurrentUser().userId).then(function (underwriterImage) {
            if (underwriterImage) {
                $scope.doesUserHasStoredImage = true;
                $scope.isSilhouetteImage = false;
                $scope.underwriterImage = 'data:image/png;base64,' + underwriterImage;
                $scope.userImage = $scope.underwriterImage;
            } else {
                setSilhouetteImage();
            }
        });
    }

    function setSilhouetteImage() {
        $scope.underwriterImage = userImage;
        $scope.userImage = $scope.underwriterImage;
        $scope.isSilhouetteImage = true;
    }

    function loadUserProfile() {
        let currentUser,
            isAgentUser;
        coreMediator.loadUser().then(function (userProfile) {
            $scope.viewModel = userProfile;

            currentUser = currentUserModel.getCurrentUser(),
                isAgentUser = (currentUser.userType === 'Agent');
            coreMediator.loadDefaultPreferences().then(function (preferences) {
                if ((appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM_AGENT && preferences['system.disablePasswordAndProfileManagementAgent'].value === 'false') ||
                    (appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM && preferences['system.disablePasswordAndProfileManagementUnderwriter'].value === 'false') ||
                    (appTypeConfigurationModel.getConsoleType() === coreConstant.authorization.CONSOLE_TYPE_UM_STUDIO && preferences['system.disablePasswordAndProfileManagementConfigurator'].value === 'false')) {
                    $scope.viewModel.isProfileManagementEnabled = true;
                }
            });
        });
    }

    init();
    loadUserProfile();
    loadDataSets();
    showUserProfileImage();


    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('umCore')
    .controller('userProfileModalController', UserProfileModalController);
